import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ExamsPage from "./ExamsPage";
import ExamDetailDrawer from "../components/ExamDetailDrawer";

/**
 * Sınavlar listesi + detay drawer.
 * /dashboard/exam-management/:examId/detail URL'inde drawer açık gösterilir.
 */
const ExamsWithDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { examId } = useParams<{ examId: string }>();
  const location = useLocation();

  const handleCloseDrawer = () => {
    const stateTab = (location.state as { activeTab?: number } | null)
      ?.activeTab;
    const statePageSize = (location.state as { pageSize?: number } | null)
      ?.pageSize;
    navigate("/dashboard/exam-management", {
      state:
        typeof stateTab === "number" || typeof statePageSize === "number"
          ? {
              ...(typeof stateTab === "number" ? { activeTab: stateTab } : {}),
              ...(typeof statePageSize === "number"
                ? { pageSize: statePageSize }
                : {}),
            }
          : undefined,
    });
  };

  return (
    <>
      <ExamsPage />
      <ExamDetailDrawer
        isOpen={!!examId}
        onClose={handleCloseDrawer}
        examId={examId ?? null}
      />
    </>
  );
};

export default ExamsWithDetailPage;
